// MUTATIONS
export const SET_IS_MODAL_VISIBLE = 'setIsModalVisible';
export const SET_SELECTED_JOB_TITLE = 'setSelectedJobTitle';
export const SET_IS_LOADING = 'isLoading';
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';

// ACTIONS
export const ACTION_GET_JOB_TITLES = 'getJobTitles';
export const ACTION_ADD_JOB_TITLE = 'addJobTitle';
export const ACTION_UPDATE_JOB_TITLE = 'updateJobTitle';
export const ACTION_REMOVE_JOB_TITLE = 'removeJobTitle';
export const ACTION_SHOW_MODAL = 'showModal';
export const ACTION_HIDE_MODAL = 'hideModal';
export const ACTION_UPDATE_JOB_TITLE_OVP_JOB_CONDITIONS = 'updateJobTitleOvpJobConditions';

// GETTERS
export const GET_SELECTED_JOB_TITLE = 'selectedJobTitle';
export const GET_IS_LOADING = 'isLoading';
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';
export const GET_IS_MODAL_VISIBLE = 'isModalVisible';